var _linearGradient, _g, _filter, _linearGradient2, _filter2, _linearGradient3, _filter3, _linearGradient4, _filter4, _linearGradient5, _filter5, _linearGradient6, _filter6, _linearGradient7, _filter7, _linearGradient8, _filter8, _linearGradient9, _filter9, _linearGradient10, _filter10, _linearGradient11, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _path6, _g5, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDimond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_1292_4825"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84.23495888710022%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "master_svg1_1371_05588/1311_4873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.515114203125,5.253903906250001C0.408700703125,5.43956390625,0.432232903125,5.672353906250001,0.573649203125,5.83296390625L7.627998203125,13.84460390625C7.827188203125,14.07080390625,8.179748203125001,14.07070390625,8.378768203125,13.84430390625L15.425058203125,5.83000390625C15.567158203125,5.66840390625,15.589858203125,5.43403390625,15.481558203125,5.2481139062499995L13.575458203125,1.97725790625C13.485858203125,1.82354230625,13.321358203125,1.72900390625,13.143458203125,1.72900390625L7.986798203125,1.72901407875L2.825208203125,1.72900390625C2.646008203125,1.72900390625,2.480518203125,1.82489820625,2.391408203125,1.9803659062499999L0.515114203125,5.253903906250001Z",
    fill: "url(#master_svg0_1292_4825)",
    fillOpacity: 1
  })))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg2_1371_05588/1311_4872",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.100851300346433,
    y: -0.11467028327575629,
    width: 1.201702600692866,
    height: 1.2293405665515127
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg3_1292_4861"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "6.428571790456772%",
    stopColor: "#F6F6F6",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69.7788655757904%",
    stopColor: "#E4E4E4",
    stopOpacity: 1
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg4_1371_05588/1311_4864",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.12183858124989651,
    y: -0.11455941047970528,
    width: 1.243677162499793,
    height: 1.2291188209594106
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.7190402746200562,
    y1: 0.16407781839370728,
    x2: 0.5234660048873673,
    y2: 0.8469119149924886,
    id: "master_svg5_1292_4849"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFDFDF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.34904909133911%",
    stopColor: "#DCDCDC",
    stopOpacity: 1
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg6_1371_05588/1311_4863",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.12127020329588166,
    y: -0.11509538352796599,
    width: 1.2425404065917633,
    height: 1.230190767055932
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.7190402746200562,
    y1: 0.16407781839370728,
    x2: 0.5200323267774952,
    y2: 0.8460366832141619,
    id: "master_svg7_1292_4852"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.19085884094238%",
    stopColor: "#DFDFDF",
    stopOpacity: 1
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg8_1371_05588/1311_4867",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.10083902188625116,
    y: -0.08084287533903263,
    width: 1.2016780437725023,
    height: 1.1616857506780653
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg9_1292_4858"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3.57142873108387%",
    stopColor: "#CECECE",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.306403160095215%",
    stopColor: "#DCDCDC",
    stopOpacity: 1
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svga_1371_05588/1311_4865",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.1524196971058056,
    y: -0.15386384576256898,
    width: 1.3048393942116112,
    height: 1.307727691525138
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.6130929589271545,
    y1: 0,
    x2: 0.4978750009050889,
    y2: 0.9997551019684398,
    id: "master_svgb_1292_4846"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E1E1E1",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDEDED",
    stopOpacity: 1
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgc_1371_05588/1311_4866",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.1530385444178039,
    y: -0.1551164725965236,
    width: 1.3060770888356077,
    height: 1.3102329451930472
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.6130929589271545,
    y1: 0,
    x2: 0.4969492234965189,
    y2: 0.9996455457831298,
    id: "master_svgd_1292_4855"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAEAEA",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FAFAFA",
    stopOpacity: 1
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svge_1371_05588/1311_4868",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.08669833727374957,
    y: -0.07643827903438008,
    width: 1.173396674547499,
    height: 1.15287655806876
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5465019345283508,
    y1: 0.04650310054421425,
    x2: 0.6776459379939548,
    y2: 0.7885421313239513,
    id: "master_svgf_1292_4864"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DBDBDB",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.71428298950195%",
    stopColor: "#E7E7E7",
    stopOpacity: 1
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgg_1371_05588/1311_4870",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.08697654708735544,
    y: -0.07650818408570047,
    width: 1.173953094174711,
    height: 1.153016368171401
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5465019345283508,
    y1: 0.04650310054421425,
    x2: 0.6770597638718145,
    y2: 0.788616090890397,
    id: "master_svgh_1292_4867"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B2B2B2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92.14285612106323%",
    stopColor: "#797979",
    stopOpacity: 1
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgi_1371_05588/1311_4871",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.34311503281535843,
    y: -0.217722337096947,
    width: 1.6862300656307168,
    height: 1.435444674193894
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6666666865348816,
    result: "effect1_foregroundBlur"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.611672043800354,
    y1: 0.5618814826011658,
    x2: 0.47024097990232944,
    y2: 0.28769333438530553,
    id: "master_svgj_1292_4871"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.712406635284424%",
    stopColor: "#FFEEC2",
    stopOpacity: 0
  }))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgk_1371_05588/1311_4869",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.05877509867867352,
    y: -0.14037974234252903,
    width: 1.117550197357347,
    height: 1.280759484685058
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1666666716337204,
    result: "effect1_foregroundBlur"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.21401217579841614,
    y1: 0.0800066813826561,
    x2: 0.8246238447766817,
    y2: 0.42434081899174125,
    id: "master_svgl_1292_4822"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF8E2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.80071997642517%",
    stopColor: "#FFEFC0",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.515114203125,5.253903906250001C0.408700703125,5.43956390625,0.432232903125,5.672353906250001,0.573649203125,5.83296390625L7.627998203125,13.84460390625C7.827188203125,14.07080390625,8.179748203125001,14.07070390625,8.378768203125,13.84430390625L15.425058203125,5.83000390625C15.567158203125,5.66840390625,15.589858203125,5.43403390625,15.481558203125,5.2481139062499995L13.575458203125,1.97725790625C13.485858203125,1.82354230625,13.321358203125,1.72900390625,13.143458203125,1.72900390625L7.986798203125,1.72901407875L2.825208203125,1.72900390625C2.646008203125,1.72900390625,2.480518203125,1.82489820625,2.391408203125,1.9803659062499999L0.515114203125,5.253903906250001Z",
    fill: "#F7F7F7",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#master_svg1_1371_05588/1311_4873)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,12.100730895996094)",
    style: {
      opacity: 0.4000000059604645
    },
    filter: "url(#master_svg2_1371_05588/1311_4872)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6959228515625,6.075084647998047L7.9915728515625,11.864135447998047L11.306312851562499,6.050365447998047L4.6959228515625,6.075084647998047Z",
    fill: "url(#master_svg3_1292_4861)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000001192092896
    },
    filter: "url(#master_svg4_1371_05588/1311_4864)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9918212890625,0.23640060424804688L11.3072912890625,6.055800604248047L13.463541289062501,1.6643706042480468L7.9918212890625,0.23640060424804688Z",
    fill: "url(#master_svg5_1292_4849)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000001192092896
    },
    filter: "url(#master_svg6_1371_05588/1311_4863)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4947509765625,1.6403946875L4.697670976562501,6.0296046875L7.9921209765625,0.2373046875L2.4947509765625,1.6403946875Z",
    fill: "url(#master_svg7_1292_4852)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    },
    filter: "url(#master_svg8_1371_05588/1311_4867)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6944580078125,6.024669647216797L8.0023380078125,14.271119647216796L11.3056580078125,6.048962047216797L7.9979280078125,6.024669647216797L4.6944580078125,6.024669647216797Z",
    fill: "url(#master_svg9_1292_4858)",
    fillOpacity: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,12.100730895996094)",
    filter: "url(#master_svga_1371_05588/1311_4865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3057861328125,6.050365447998047L13.4353261328125,10.383205447998048L15.6796761328125,6.539818447998047L11.3057861328125,6.050365447998047Z",
    fill: "url(#master_svgb_1292_4846)",
    fillOpacity: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,12.047019958496094)",
    filter: "url(#master_svgc_1371_05588/1311_4866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3414306640625,6.487998979248047L2.5417106640625,10.318749979248047L4.6976306640625,6.020905809248047L0.3414306640625,6.487998979248047Z",
    fill: "url(#master_svgd_1292_4855)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    filter: "url(#master_svge_1371_05588/1311_4868)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.3210856153125,5.563060760498047L8.0105814453125,14.284690760498046L4.6931114453125,6.024771760498047L0.3210856153125,5.563060760498047Z",
    fill: "url(#master_svgf_1292_4864)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,31.329345703125,0)",
    style: {
      opacity: 0.4000000059604645
    },
    filter: "url(#master_svgg_1371_05588/1311_4870)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6646706321025,5.559399761216797L23.3295728515625,14.273065897216798L20.0381428515625,6.050902897216797L15.6646706321025,5.559399761216797Z",
    fill: "url(#master_svgh_1292_4867)",
    fillOpacity: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svgi_1371_05588/1311_4871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.814895507812501,7.07115015625L7.6910465078125,13.83281015625L8.4322445078125,14.50411015625L14.5560955078125,7.74244015625Q15.4014655078125,6.80903015625,15.5285955078125,5.55613015625Q15.6557155078125,4.30324015625,15.0150555078125,3.21905015625L14.097375507812501,1.66604515625L13.236445507812501,2.17477515625L14.1541255078125,3.7277801562499997Q14.6276555078125,4.52913015625,14.5336955078125,5.45519015625Q14.4397355078125,6.38124015625,13.814895507812501,7.07115015625Z",
    fillRule: "evenodd",
    fill: "url(#master_svgj_1292_4871)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    filter: "url(#master_svgk_1371_05588/1311_4869)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4057103515625,2.1158956640625L2.6573503515625,2.1158956640625L1.6640203515625,3.9499656640625L1.1674403515625,4.866985664062501L0.9190673515625,5.3254956640625L0.5001223515625,6.1060756640625L0.1666263515625,5.9205156640625L0.0631103515625,5.6796756640625L0.5000603515625,4.866985664062501L0.7662333515625,4.3763456640625L1.2985803515625,3.3950856640625L2.3632703515625,1.4325561640625L11.4058103515625,1.3570556640625L11.4057103515625,2.1158956640625Z",
    fillRule: "evenodd",
    fill: "url(#master_svgl_1292_4822)",
    fillOpacity: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimond);
export default __webpack_public_path__ + "static/media/dimond.18f82ca9.svg";
export { ForwardRef as ReactComponent };